// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod";

export const zAbstractPersistentObject = z.object({
  id: z.string().nullish(),
});

export const zArtificialAvalancheReleaseProbability = z.enum(["one", "two", "three", "four"]);

export const zAspect = z.enum(["N", "NE", "E", "SE", "S", "SW", "W", "NW"]);

export const zAuthenticationServiceCredentials = z.object({
  username: z.string(),
  password: z.string(),
});

export const zAuthenticationServiceUsername = z.object({
  username: z.string(),
});

export const zAvalancheBulletinValidity = z.object({
  from: z.iso.datetime().optional(),
  until: z.iso.datetime().optional(),
});

export const zAvalancheBulletinPhoto = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    url: z.string().optional(),
    copyright: z.string().optional(),
    date: z.iso.date().optional(),
    microRegionId: z.string().optional(),
    locationName: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
  }),
);

export const zAvalancheBulletinServiceLatestBulletin = z.object({
  date: z.iso.datetime(),
});

export const zAvalancheProblem1 = z.enum([
  "new_snow",
  "wind_slab",
  "persistent_weak_layers",
  "wet_snow",
  "gliding_snow",
  "favourable_situation",
  "cornices",
  "no_distinct_avalanche_problem",
]);

export const zAvalancheSize = z.enum(["small", "medium", "large", "very_large", "extreme"]);

export const zAvalancheType = z.enum(["slab", "loose", "glide"]);

export const zBlogItem = z.object({
  id: z.string(),
  title: z.string(),
  content: z.string(),
  published: z.iso.datetime(),
  categories: z.array(z.string()),
  attachmentUrl: z.string(),
  translations: z.object({
    de: z.string().optional(),
    it: z.string().optional(),
    en: z.string().optional(),
    fr: z.string().optional(),
    es: z.string().optional(),
    ca: z.string().optional(),
    oc: z.string().optional(),
  }),
});

export const zBulletinStatus = z.enum([
  "republished",
  "resubmitted",
  "updated",
  "published",
  "submitted",
  "draft",
  "missing",
]);

export const zAvalancheBulletinStatusServiceStatus = z.object({
  date: z.iso.datetime(),
  timestamp: z.iso.datetime(),
  status: zBulletinStatus,
  isBeingPublished: z.boolean(),
});

/**
 * An aspect can be defined as a set of aspects. The aspects are the expositions as in a eight part (45°) segments. The allowed aspects are the four main cardinal directions and the four intercardinal directions.
 */
export const zCaamlAspect = z
  .enum(["E", "N", "NE", "NW", "n/a", "S", "SE", "SW", "W"])
  .describe(
    "An aspect can be defined as a set of aspects. The aspects are the expositions as in a eight part (45°) segments. The allowed aspects are the four main cardinal directions and the four intercardinal directions.",
  );

export const zCaamlAvalancheBulletinCustomDataBulletinPhoto = z.object({
  url: z.string(),
  copyright: z.string().nullish(),
  date: z.iso.date().nullish(),
  microRegionId: z.string().nullish(),
  locationName: z.string().nullish(),
  latitude: z.number().nullish(),
  longitude: z.number().nullish(),
});

export const zCaamlAvalancheBulletinCustomDataLwdTyrol = z.object({
  dangerPatterns: z.array(z.string()).nullish(),
});

export const zCaamlAvalancheBulletinsCustomDataAlbina = z.object({
  generalHeadline: z.string(),
});

export const zCaamlAvalancheBulletinsCustomData = z.object({
  ALBINA: zCaamlAvalancheBulletinsCustomDataAlbina,
});

export const zCaamlAvalancheProblemCustomDataAlbina = z.object({
  avalancheType: z.string(),
});

export const zCaamlAvalancheProblemCustomData = z.object({
  ALBINA: zCaamlAvalancheProblemCustomDataAlbina,
});

/**
 * Expected avalanche problem, according to the EAWS avalanche problem definition.
 */
export const zCaamlAvalancheProblemType = z
  .enum([
    "cornices",
    "favourable_situation",
    "gliding_snow",
    "new_snow",
    "no_distinct_avalanche_problem",
    "persistent_weak_layers",
    "wet_snow",
    "wind_slab",
  ])
  .describe("Expected avalanche problem, according to the EAWS avalanche problem definition.");

/**
 * Expected avalanche type.
 */
export const zCaamlAvalancheTypeType = z.enum(["slab", "loose", "glide"]).describe("Expected avalanche type.");

/**
 * Danger rating value, according to EAWS danger scale definition.
 */
export const zCaamlDangerRatingValue = z
  .enum(["considerable", "high", "low", "moderate", "no_rating", "no_snow", "very_high"])
  .describe("Danger rating value, according to EAWS danger scale definition.");

export const zCaamlAvalancheBulletinCustomDataTendencyProgression = z.object({
  dates: z.array(z.iso.date()),
  dangerRatings: z.record(z.string(), z.array(zCaamlDangerRatingValue)),
});

export const zCaamlAvalancheBulletinCustomDataAlbina = z.object({
  mainDate: z.string(),
  tendencyProgression: zCaamlAvalancheBulletinCustomDataTendencyProgression.nullish(),
  bulletinPhotos: z.array(zCaamlAvalancheBulletinCustomDataBulletinPhoto).nullish(),
});

export const zCaamlAvalancheBulletinCustomData = z.object({
  ALBINA: zCaamlAvalancheBulletinCustomDataAlbina,
  LWD_Tyrol: zCaamlAvalancheBulletinCustomDataLwdTyrol,
});

/**
 * Elevation describes either an elevation range below a certain bound (only upperBound is set to a value) or above a certain bound (only lowerBound is set to a value). If both values are set to a value, an elevation band is defined by this property. The value uses a numeric value, not more detailed than 100m resolution. Additionally to the numeric values also 'treeline' is allowed.
 */
export const zCaamlElevationBoundaryOrBand = z
  .object({
    lowerBound: z.string().optional(),
    upperBound: z.string().optional(),
  })
  .describe(
    "Elevation describes either an elevation range below a certain bound (only upperBound is set to a value) or above a certain bound (only lowerBound is set to a value). If both values are set to a value, an elevation band is defined by this property. The value uses a numeric value, not more detailed than 100m resolution. Additionally to the numeric values also 'treeline' is allowed.",
  );

/**
 * Expected frequency of lowest snowpack stability, according to the EAWS definition. Three stage scale (few, some, many).
 */
export const zCaamlExpectedAvalancheFrequency = z
  .enum(["few", "many", "none", "some"])
  .describe(
    "Expected frequency of lowest snowpack stability, according to the EAWS definition. Three stage scale (few, some, many).",
  );

/**
 * Snowpack stability, according to the EAWS definition. Four stage scale (very poor, poor, fair, good).
 */
export const zCaamlExpectedSnowpackStability = z
  .enum(["fair", "good", "poor", "very_poor"])
  .describe("Snowpack stability, according to the EAWS definition. Four stage scale (very poor, poor, fair, good).");

/**
 * External file is used to link to external files like maps, thumbnails etc.
 */
export const zCaamlExternalFile = z
  .object({
    description: z.string().optional(),
    fileReferenceURI: z.string().optional(),
    fileType: z.string().optional(),
  })
  .describe("External file is used to link to external files like maps, thumbnails etc.");

/**
 * Meta data for various uses. Can be used to link to external files like maps, thumbnails etc.
 */
export const zCaamlMetaData = z
  .object({
    comment: z.string().optional(),
    EXTFiles: z.array(zCaamlExternalFile).optional(),
  })
  .describe("Meta data for various uses. Can be used to link to external files like maps, thumbnails etc.");

/**
 * Details on a person.
 */
export const zCaamlPerson = z
  .object({
    customData: z.record(z.string(), z.unknown()).optional(),
    metaData: zCaamlMetaData.optional(),
    name: z.string().optional(),
    website: z.string().optional(),
  })
  .describe("Details on a person.");

/**
 * Information about the bulletin provider. Defines the name, website and/or contactPerson (which could be the author) of the issuing AWS.
 */
export const zCaamlAvalancheBulletinProvider = z
  .object({
    contactPerson: zCaamlPerson.optional(),
    customData: z.record(z.string(), z.unknown()).optional(),
    metaData: zCaamlMetaData.optional(),
    name: z.string().optional(),
    website: z.string().optional(),
  })
  .describe(
    "Information about the bulletin provider. Defines the name, website and/or contactPerson (which could be the author) of the issuing AWS.",
  );

/**
 * Details about the issuer/AWS of the bulletin. Information about the bulletin source. Either as in a person or with a provider element to specify details about the AWS.
 */
export const zCaamlAvalancheBulletinSource = z
  .object({
    person: zCaamlPerson.optional(),
    provider: zCaamlAvalancheBulletinProvider.optional(),
  })
  .describe(
    "Details about the issuer/AWS of the bulletin. Information about the bulletin source. Either as in a person or with a provider element to specify details about the AWS.",
  );

/**
 * Region element describes a (micro) region. The regionID follows the EAWS schema. It is recommended to have the region shape's files with the same IDs in gitlab.com/eaws/eaws-regions. Additionally, the region name can be added.
 */
export const zCaamlRegion = z
  .object({
    customData: z.record(z.string(), z.unknown()).optional(),
    metaData: zCaamlMetaData.optional(),
    name: z.string().optional(),
    regionID: z.string().optional(),
  })
  .describe(
    "Region element describes a (micro) region. The regionID follows the EAWS schema. It is recommended to have the region shape's files with the same IDs in gitlab.com/eaws/eaws-regions. Additionally, the region name can be added.",
  );

export const zCaamlTendencyType = z.enum(["decreasing", "increasing", "steady"]);

/**
 * Texts element with highlight and comment for the avalanche activity. Texts contains a highlight and a comment string, where highlights could also be described as a kind of headline for the longer comment. For text-formatting the HTML-Tags
 * for a new line, (
 *
 * ,) and (
 * * ,
 * * ) for lists, (
 *
 * ,
 * ===
 *
 * ) to (
 * ======
 *
 * ###### ,
 *
 * ###### ) for
 * headings and (**,**) for a bold text are allowed.
 * Texts element with highlight and comment for details on the snowpack structure.
 * Texts element with highlight and comment for travel advisory.
 * Texts element with highlight and comment for weather forecast information.
 * Texts element with highlight and comment for weather review information.
 */
export const zCaamlTexts = z
  .object({
    comment: z.string().optional(),
    highlights: z.string().optional(),
  })
  .describe(
    "Texts element with highlight and comment for the avalanche activity. Texts contains a highlight and a comment string, where highlights could also be described as a kind of headline for the longer comment. For text-formatting the HTML-Tags   \nfor a new line, (\n\n,) and (\n* ,\n* ) for lists, (\n\n  ,\n  ===\n\n  ) to (\n  ======\n\n  ###### ,\n\n  ###### ) for\n  headings and (**,**) for a bold text are allowed.\n  Texts element with highlight and comment for details on the snowpack structure.\n  Texts element with highlight and comment for travel advisory.\n  Texts element with highlight and comment for weather forecast information.\n  Texts element with highlight and comment for weather review information.",
  );

/**
 * Valid time defines two ISO 8601 timestamps in UTC or with time zone information. Date and Time from and until this bulletin is valid. ISO 8601 Timestamp in UTC or with time zone information.
 */
export const zCaamlValidTime = z
  .object({
    endTime: z.iso.datetime().optional(),
    startTime: z.iso.datetime().optional(),
  })
  .describe(
    "Valid time defines two ISO 8601 timestamps in UTC or with time zone information. Date and Time from and until this bulletin is valid. ISO 8601 Timestamp in UTC or with time zone information.",
  );

/**
 * Texts element with highlight and comment for the avalanche activity. Texts contains a highlight and a comment string, where highlights could also be described as a kind of headline for the longer comment. For text-formatting the HTML-Tags
 * for a new line, (
 *
 * ,) and (
 * * ,
 * * ) for lists, (
 *
 * ,
 * ===
 *
 * ) to (
 * ======
 *
 * ###### ,
 *
 * ###### ) for
 * headings and (**,**) for a bold text are allowed.
 * Texts element with highlight and comment for details on the snowpack structure.
 * Texts element with highlight and comment for travel advisory.
 * Texts element with highlight and comment for weather forecast information.
 * Texts element with highlight and comment for weather review information.
 * Describes the expected tendency of the development of the avalanche situation for a
 * defined time period.
 */
export const zCaamlTendency = z
  .object({
    comment: z.string().optional(),
    highlights: z.string().optional(),
    customData: z.record(z.string(), z.unknown()).optional(),
    metaData: zCaamlMetaData.optional(),
    tendencyType: zCaamlTendencyType.optional(),
    validTime: zCaamlValidTime.optional(),
  })
  .describe(
    "Texts element with highlight and comment for the avalanche activity. Texts contains a highlight and a comment string, where highlights could also be described as a kind of headline for the longer comment. For text-formatting the HTML-Tags   \nfor a new line, (\n\n,) and (\n* ,\n* ) for lists, (\n\n  ,\n  ===\n\n  ) to (\n  ======\n\n  ###### ,\n\n  ###### ) for\n  headings and (**,**) for a bold text are allowed.\n  Texts element with highlight and comment for details on the snowpack structure.\n  Texts element with highlight and comment for travel advisory.\n  Texts element with highlight and comment for weather forecast information.\n  Texts element with highlight and comment for weather review information.\n  Describes the expected tendency of the development of the avalanche situation for a\n  defined time period.",
  );

/**
 * Valid time period can be used to limit the validity of an element to an earlier or later period. It can be used to distinguish danger ratings or avalanche problems.
 */
export const zCaamlValidTimePeriod = z
  .enum(["all_day", "earlier", "later"])
  .describe(
    "Valid time period can be used to limit the validity of an element to an earlier or later period. It can be used to distinguish danger ratings or avalanche problems.",
  );

/**
 * Defines an avalanche problem, its time, aspect, and elevation constraints. A textual detail about the affected terrain can be given in the comment field. Also, details about the expected avalanche size, snowpack stability and its frequency can be defined. The implied danger rating value is optional.
 */
export const zCaamlAvalancheProblem = z
  .object({
    aspects: z.array(zCaamlAspect).optional(),
    avalancheSize: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    comment: z.string().optional(),
    customData: zCaamlAvalancheProblemCustomData.optional(),
    dangerRatingValue: zCaamlDangerRatingValue.optional(),
    elevation: zCaamlElevationBoundaryOrBand.optional(),
    frequency: zCaamlExpectedAvalancheFrequency.optional(),
    metaData: zCaamlMetaData.optional(),
    problemType: zCaamlAvalancheProblemType.optional(),
    avalancheType: zCaamlAvalancheTypeType.optional(),
    snowpackStability: zCaamlExpectedSnowpackStability.optional(),
    validTimePeriod: zCaamlValidTimePeriod.optional(),
  })
  .describe(
    "Defines an avalanche problem, its time, aspect, and elevation constraints. A textual detail about the affected terrain can be given in the comment field. Also, details about the expected avalanche size, snowpack stability and its frequency can be defined. The implied danger rating value is optional.",
  );

/**
 * Defines a danger rating, its elevation constraints and the valid time period. If validTimePeriod or elevation are constrained for a rating, it is expected to define a dangerRating for all the other cases.
 */
export const zCaamlDangerRating = z
  .object({
    aspects: z.array(zCaamlAspect).optional(),
    customData: z.record(z.string(), z.unknown()).optional(),
    elevation: zCaamlElevationBoundaryOrBand.optional(),
    mainValue: zCaamlDangerRatingValue.optional(),
    metaData: zCaamlMetaData.optional(),
    validTimePeriod: zCaamlValidTimePeriod.optional(),
  })
  .describe(
    "Defines a danger rating, its elevation constraints and the valid time period. If validTimePeriod or elevation are constrained for a rating, it is expected to define a dangerRating for all the other cases.",
  );

/**
 * Avalanche Bulletin valid for a given set of regions.
 */
export const zCaamlAvalancheBulletin = z
  .object({
    avalancheActivity: zCaamlTexts.optional(),
    avalancheProblems: z
      .array(zCaamlAvalancheProblem)
      .describe("Collection of Avalanche Problem elements for this bulletin.")
      .optional(),
    bulletinID: z.string().describe("Unique ID for the bulletin.").optional(),
    customData: zCaamlAvalancheBulletinCustomData.optional(),
    dangerRatings: z
      .array(zCaamlDangerRating)
      .describe("Collection of Danger Rating elements for this bulletin.")
      .optional(),
    highlights: z
      .string()
      .describe("Contains an optional short text to highlight an exceptionally dangerous situation.")
      .optional(),
    lang: z.string().describe("Two-letter language code (ISO 639-1).").optional(),
    metaData: zCaamlMetaData.optional(),
    nextUpdate: z.iso
      .datetime()
      .describe(
        "Time and date when the next bulletin will be published by the AWS to the Public. ISO 8601 timestamp in UTC or with time zone information.",
      )
      .optional(),
    publicationTime: z.iso
      .datetime()
      .describe(
        "Time and date when the bulletin was issued by the AWS to the Public. ISO 8601 timestamp in UTC or with time zone information.",
      )
      .optional(),
    regions: z
      .array(zCaamlRegion)
      .describe("Collection of region elements for which this bulletin is valid.")
      .optional(),
    snowpackStructure: zCaamlTexts.optional(),
    source: zCaamlAvalancheBulletinSource.optional(),
    tendency: z
      .array(zCaamlTendency)
      .describe(
        "Tendency element for a detailed description of the expected avalanche situation tendency after the bulletin's period of validity.",
      )
      .optional(),
    travelAdvisory: zCaamlTexts.optional(),
    unscheduled: z.boolean().describe("Flag if bulletin is unscheduled or not.").optional(),
    validTime: zCaamlValidTime.optional(),
    weatherForecast: zCaamlTexts.optional(),
    weatherReview: zCaamlTexts.optional(),
  })
  .describe("Avalanche Bulletin valid for a given set of regions.");

/**
 * JSON schema for EAWS avalanche bulletin collection following the CAAMLv6 schema
 */
export const zCaamlAvalancheBulletins = z
  .object({
    bulletins: z.array(zCaamlAvalancheBulletin).optional(),
    customData: zCaamlAvalancheBulletinsCustomData.optional(),
    metaData: zCaamlMetaData.optional(),
  })
  .describe("JSON schema for EAWS avalanche bulletin collection following the CAAMLv6 schema");

/**
 * The version of CAAML (Canadian Avalanche Association Markup Language)
 */
export const zCaamlVersion = z
  .enum(["V6", "V6_JSON"])
  .describe("The version of CAAML (Canadian Avalanche Association Markup Language)");

export const zCharacteristic = z.enum(["low", "medium", "high", "very_high"]);

export const zComplexity = z.enum(["easy", "challenging", "complex"]);

export const zCreationProcess = z.enum([
  "radiation_recrystallization",
  "diurnal_recrystallization",
  "melt_layer_recrystallization",
  "surface_hoar_formation",
]);

export const zCrust = z.enum(["no", "partly", "yes"]);

export const zDangerPattern = z.enum(["dp1", "dp2", "dp3", "dp4", "dp5", "dp6", "dp7", "dp8", "dp9", "dp10"]);

export const zDangerRating = z.enum([
  "missing",
  "no_snow",
  "no_rating",
  "low",
  "moderate",
  "considerable",
  "high",
  "very_high",
]);

export const zAvalancheBulletinServiceHighest = z.object({
  dangerRating: zDangerRating,
});

export const zDangerRatingModificator = z.enum(["none", "minus", "equal", "plus"]);

export const zDangerSign = z.enum(["shooting_cracks", "whumpfing", "fresh_avalanches", "glide_cracks"]);

/**
 * This class holds all information about one danger source.
 */
export const zDangerSource = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    ownerRegion: z.string().optional(),
    creationDate: z.iso.datetime().optional(),
    title: z.string().optional(),
    description: z.string().optional(),
  }),
);

export const zDangerSourceVariantStatus = z.enum(["active", "dormant", "inactive"]);

export const zDangerSourceVariantType = z.enum(["forecast", "analysis"]);

export const zDangerSourceVariantsStatus = z.object({
  date: z.iso.datetime(),
  forecast: z.boolean(),
  analysis: z.boolean(),
});

export const zDaytime = z.enum([
  "evening",
  "first_night_half",
  "second_night_half",
  "morning",
  "forenoon",
  "afternoon",
]);

export const zDirection = z.enum(["up", "down"]);

export const zDistribution = z.enum(["isolated", "specific", "widespread"]);

export const zFrequency = z.enum(["none", "few", "some", "many"]);

export const zGenericObservationImportantObservation = z.enum([
  "SnowLine",
  "SurfaceHoar",
  "Graupel",
  "StabilityTest",
  "IceFormation",
  "VeryLightNewSnow",
  "ForBlog",
]);

export const zGenericObservationObservationType = z.enum([
  "SimpleObservation",
  "Evaluation",
  "Avalanche",
  "Blasting",
  "Closure",
  "Profile",
  "TimeSeries",
  "Webcam",
  "DrySnowfallLevel",
]);

export const zGenericObservationPersonInvolvement = z.enum(["Dead", "Injured", "Uninjured", "No", "Unknown"]);

export const zGenericObservation = z.object({
  $source: z.string().describe("Source of this observation"),
  $id: z.string().describe("External ID of this observation"),
  $type: zGenericObservationObservationType,
  $externalURL: z.string().describe("External URL to display as iframe").optional(),
  stability: z.string().describe("Snowpack stability that can be inferred from this observation").optional(),
  aspects: z.array(zAspect).describe("Aspects corresponding with this observation").optional(),
  authorName: z.string().describe("Name of the author").optional(),
  content: z.string().describe("Free-text content").optional(),
  $data: z
    .record(z.string(), z.unknown())
    .describe("Additional data (e.g. original data stored when fetching from external API)")
    .optional(),
  elevation: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .describe("Elevation in meters")
    .optional(),
  elevationLowerBound: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .describe("Lower bound of elevation in meters")
    .optional(),
  elevationUpperBound: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .describe("Upper bound of elevation in meters")
    .optional(),
  eventDate: z.iso.datetime().describe("Date when the event occurred").optional(),
  latitude: z.number().describe("Location latitude (WGS 84)").optional(),
  locationName: z.string().describe("Location name").optional(),
  longitude: z.number().describe("Location longitude (WGS 84)").optional(),
  region: z.string().describe("Micro-region code (possibly computed from latitude/longitude)").optional(),
  reportDate: z.iso.datetime().describe("Date when the observation has been reported").optional(),
  avalancheProblems: z
    .array(zAvalancheProblem1)
    .describe("Avalanche problems corresponding with this observation")
    .optional(),
  dangerPatterns: z.array(zDangerPattern).describe("Danger patterns corresponding with this observation").optional(),
  importantObservation: z.array(zGenericObservationImportantObservation).describe("Important observations").optional(),
  extraDialogRows: z
    .record(z.string(), z.unknown())
    .describe("Additional information to display as table rows in the observation dialog")
    .optional(),
  $externalImgs: z
    .string()
    .describe("External image to display. Multiple images are persisted using line separator.")
    .optional(),
  personInvolvement: zGenericObservationPersonInvolvement.optional(),
  $deleted: z.boolean().describe("Observations marked as deleted will no longer be returned in the list").optional(),
  allowEdit: z.boolean().describe("Allows modifying observations fetched from external sources").optional(),
  dangerSource: zDangerSource.nullish(),
});

export const zGlidingSnowActivity = z.enum(["low", "medium", "high"]);

export const zGrainShape = z.enum([
  "PP",
  "MM",
  "DF",
  "RG",
  "FC",
  "DH",
  "SH",
  "MF",
  "IF",
  "PPco",
  "PPnd",
  "PPpl",
  "PPsd",
  "PPir",
  "PPgp",
  "PPhl",
  "PPip",
  "PPrm",
  "MMrp",
  "MMci",
  "DFdc",
  "DFbk",
  "RGsr",
  "RGlr",
  "RGwp",
  "RGxf",
  "FCso",
  "FCsf",
  "FCxr",
  "DHcp",
  "DHpr",
  "DHch",
  "DHla",
  "DHxr",
  "SHsu",
  "SHcv",
  "SHxr",
  "MFcl",
  "MFpc",
  "MFsl",
  "MFcr",
  "IFil",
  "IFic",
  "IFbi",
  "IFrc",
  "IFsc",
]);

export const zHandHardness = z.enum(["fist", "four_fingers", "one_finger", "pencil", "knife", "ice"]);

export const zHazardSiteDistribution = z.enum(["single", "some", "many", "many_most", "moderately_steep"]);

export const zIncident = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    createdAt: z.iso.datetime().optional(),
    updatedAt: z.iso.datetime().optional(),
    data: z.record(z.string(), z.unknown()).optional(),
    publishedAt: z.iso.datetime().optional(),
    publicData: z.record(z.string(), z.unknown()).optional(),
  }),
);

export const zIncidentAttachment = z.object({
  id: z.uuid(),
  dateAdded: z.iso.datetime(),
  fileName: z.string(),
  mediaType: z.string(),
  dateCreated: z.iso.datetime(),
  credit: z.string(),
  caption: z.string(),
  altText: z.string(),
  public: z.boolean(),
  attachmentCategory: z.string(),
  attachmentTags: z.array(z.string()),
});

export const zIncidentsAccidentalControlled = z.enum(["Accidental", "Controlled"]);

export const zIncidentsAdditionalLoad = z.enum(["High", "Low"]);

export const zIncidentsAge = z.enum([
  "From14To20",
  "From21To30",
  "From31To40",
  "From41To50",
  "From51To60",
  "From61To70",
  "From71",
  "UpTo13",
]);

export const zIncidentsAirbag = z.enum(["AirbagDeployed", "AirbagUndeployed", "NoAirbag"]);

export const zIncidentsAttachmentCategory = z.enum(["Avalanche", "Group", "Incident", "Person", "Snowpack", "Weather"]);

export const zIncidentsAttachment = z.object({
  altText: z.string(),
  attachmentCategory: zIncidentsAttachmentCategory,
  attachmentTags: z.array(z.string()),
  caption: z.string(),
  credit: z.string(),
  dateAdded: z.iso.datetime(),
  dateCreated: z.iso.datetime(),
  fileName: z.string(),
  id: z.uuid(),
  mediaType: z.string(),
  public: z.boolean(),
});

export const zIncidentsAvalancheGear = z.enum(["All", "None", "Some", "Unknown"]);

export const zIncidentsAvalancheProblemAvalancheSize = z.enum(["extreme", "large", "medium", "small", "very_large"]);

export const zIncidentsAvalancheType = z.enum(["cornice", "glide", "loose", "slab", "unknown"]);

export const zIncidentsBedSurfaceStepped = z.enum(["No", "Yes"]);

export const zIncidentsBurialDegree = z.enum([
  "FullyBuried",
  "NotBuried",
  "PartlyBuried",
  "PartlyBuriedHeadCovered",
  "PartlyBuriedHeadUncovered",
  "Unknown",
]);

export const zIncidentsCaught = z.enum(["Involved", "NotInvolved", "Unknown"]);

export const zIncidentsCriticalWarming = z.enum(["Absent", "Present", "Unknown"]);

export const zIncidentsDangerPattern = z.enum(["dp1", "dp10", "dp2", "dp3", "dp4", "dp5", "dp6", "dp7", "dp8", "dp9"]);

export const zIncidentsDangerRating = z.enum([
  "considerable",
  "high",
  "low",
  "moderate",
  "no_rating",
  "no_snow",
  "very_high",
]);

export const zIncidentsDepositMoisture = z.enum(["Dry", "Moist", "Wet"]);

export const zIncidentsEstimatedTimeOfDeath = z.enum([
  "DuringBurial",
  "DuringTheAvalanche",
  "DuringTransport",
  "InHospital",
  "OnSiteAfterExtrication",
]);

export const zIncidentsFatalInjured = z.enum(["Fatal", "Injured", "Uninjured", "Unknown"]);

export const zIncidentsFrequency = z.enum(["few", "many", "none", "some"]);

export const zIncidentsGender = z.enum(["Female", "Male", "Other"]);

export const zIncidentsGroupSizeAccuracy = z.enum(["Approximately", "AtLeast", "Exact", "Unknown"]);

export const zIncidentsIncidentSchemaAvalancheSize = z.enum([
  "extreme",
  "large",
  "large_very_large",
  "medium",
  "medium_large",
  "small",
  "small_medium",
  "unknown",
  "very_large",
  "very_large_extreme",
]);

export const zIncidentsIncidentTerrainType = z.enum([
  "ControlledTerrainClosed",
  "ControlledTerrainOpen",
  "FreeTerrain",
  "Unknown",
]);

export const zIncidentsGroupInformation = z.object({
  anonymousGroupIdentifier: z.string(),
  avalancheGear: zIncidentsAvalancheGear,
  groupInformationComment: z.string(),
  groupSize: z.number(),
  groupSizeAccuracy: zIncidentsGroupSizeAccuracy,
  groupType: z.string(),
  id: z.uuid(),
  incidentActivity: z.string(),
  incidentTerrainType: zIncidentsIncidentTerrainType,
  travelDirection: z.string(),
  typeOfControlledTerrain: z.string(),
  vehicleType: z.string(),
});

export const zIncidentsInjurySeverity = z.enum(["Major", "Minor", "Moderate"]);

export const zIncidentsInvolvementsFatalitiesBurials = z.object({
  caughtOnly: z.number(),
  fatalities: z.number(),
  fullyBuried: z.number(),
  incidentActivity: z.array(z.string()),
  incidentTerrainType: z.array(zIncidentsIncidentTerrainType),
  injuredSurvivors: z.number(),
  involvementsFatalitiesBurialsComment: z.string(),
  numberInvolved: z.number(),
  numberOfGroups: z.number(),
  partlyBuried: z.number(),
  partlyBuriedHeadCovered: z.number(),
  partlyBuriedHeadUncovered: z.number(),
  uninjuredSurvivors: z.number(),
});

export const zIncidentsLocationAccuracy = z.enum([
  "exact",
  "unknown",
  "within100m",
  "within10km",
  "within15m",
  "within1km",
  "within20km",
  "within250m",
  "within2km",
  "within30m",
  "within500m",
  "within50km",
  "within5km",
]);

export const zIncidentsNatural = z.enum(["CorniceFall", "Earthquake", "IceFall", "Natural", "RockFall"]);

export const zIncidentsPerson = z.enum(["PersonAccidental", "PersonControlled"]);

export const zIncidentsPersonInvolvement = z.enum(["No", "Unknown", "Yes"]);

export const zIncidentsProblemType = z.enum([
  "cornices",
  "gliding_snow",
  "new_snow",
  "no_distinct_avalanche_problem",
  "persistent_weak_layers",
  "wet_snow",
  "wind_slab",
]);

export const zIncidentsReportStatus = z.enum(["Draft", "InReview", "Incomplete", "Verified"]);

export const zIncidentsSnowpackStability = z.enum(["fair", "good", "poor", "very_poor"]);

export const zIncidentsStartZoneAspect = z.enum(["E", "N", "NE", "NW", "S", "SE", "SW", "W"]);

export const zIncidentsAvalancheProblem = z.object({
  aspects: z.array(zIncidentsStartZoneAspect),
  avalancheSize: zIncidentsAvalancheProblemAvalancheSize,
  elevationLowerBound: z.string(),
  elevationUpperBound: z.string(),
  frequency: zIncidentsFrequency,
  problemType: zIncidentsProblemType,
  snowpackStability: zIncidentsSnowpackStability,
});

export const zIncidentsStartZoneAspectAccuracy = z.enum(["Accurate", "Uncertain"]);

export const zIncidentsStartZoneElevationAccuracy = z.enum([
  "exact",
  "unknown",
  "within100m",
  "within200m",
  "within50m",
]);

export const zIncidentsStartZoneMoisture = z.enum(["Dry", "Moist", "Unknown", "Wet"]);

export const zIncidentsTimeAccuracy = z.enum([
  "P1D",
  "P2D",
  "P3D",
  "PT12H",
  "PT15M",
  "PT1H",
  "PT2H",
  "PT30M",
  "PT4H",
  "PT6H",
  "exact",
  "unknown",
]);

export const zIncidentsTransceiver = z.enum(["NoTransceiver", "TransceiverOff", "TransceiverOn"]);

export const zIncidentsWeakLayerGrainType = z.enum(["DF", "DH", "FC", "FCxr", "MF", "MM", "PP", "PPgp", "RG", "SH"]);

export const zIncidentsWeakLayerLocation = z.enum([
  "AtInterfaceWithOldSnow",
  "NearTheGround",
  "WithinNewSnow",
  "WithinOldSnowpack",
]);

export const zIncidentsYearsActive = z.enum(["From10Years", "From3To9Years", "UpTo2Years"]);

export const zIncidentsVictimInformation = z.object({
  age: zIncidentsAge,
  airbag: zIncidentsAirbag,
  anonymousVictimIdentifier: z.string(),
  avalancheTraining: z.string(),
  burialDegree: zIncidentsBurialDegree,
  burialDepth: z.number(),
  burialDuration: z.number(),
  caught: zIncidentsCaught,
  causeOfDeath: z.string(),
  country: z.string(),
  estimatedTimeOfDeath: zIncidentsEstimatedTimeOfDeath,
  fatalInjured: zIncidentsFatalInjured,
  gender: zIncidentsGender,
  groupID: z.uuid(),
  helmet: zIncidentsBedSurfaceStepped,
  id: z.uuid(),
  injurySeverity: zIncidentsInjurySeverity,
  leaderAtTime: zIncidentsBedSurfaceStepped,
  medicalIntervention: z.string(),
  primaryLocationMethod: z.string(),
  probe: zIncidentsBedSurfaceStepped,
  professionalCertification: z.string(),
  rescuedBy: z.string(),
  respiratoryCavity: zIncidentsBedSurfaceStepped,
  shovel: zIncidentsBedSurfaceStepped,
  terrainTrap: z.string(),
  transceiver: zIncidentsTransceiver,
  victimInformationComment: z.string(),
  workingAtTime: zIncidentsBedSurfaceStepped,
  yearsActive: zIncidentsYearsActive,
});

export const zIncidentsIncidentSchema = z.object({
  accidentalControlled: zIncidentsAccidentalControlled,
  additionalLoad: zIncidentsAdditionalLoad,
  attachments: z.array(zIncidentsAttachment),
  author: z.string(),
  authorAffiliation: z.string(),
  avalancheDescription: z.record(z.string(), z.string()),
  avalancheDescriptionPublic: z.boolean(),
  avalancheDetailsComment: z.string(),
  avalancheLength: z.number(),
  avalancheProblems: z.array(zIncidentsAvalancheProblem),
  avalancheRegion: z.string(),
  avalancheSize: zIncidentsIncidentSchemaAvalancheSize,
  avalancheType: zIncidentsAvalancheType,
  bedSurfaceStepped: zIncidentsBedSurfaceStepped,
  bulletinInformationComment: z.string(),
  country: z.string(),
  criticalWarming: zIncidentsCriticalWarming,
  crownDepthAvg: z.number(),
  crownDepthMax: z.number(),
  crownDepthMin: z.number(),
  damagedAssets: z.array(z.string()),
  dangerPattern: z.array(zIncidentsDangerPattern),
  dangerRating: zIncidentsDangerRating,
  dateTime: z.iso.datetime(),
  debrisDensity: z.number(),
  debrisType: z.array(z.string()),
  depositElevation: z.number(),
  depositHeight: z.number(),
  depositMoisture: zIncidentsDepositMoisture,
  depositWidth: z.number(),
  explosives: z.string(),
  generalInformationComment: z.string(),
  groupInformation: z.array(zIncidentsGroupInformation),
  id: z.uuid(),
  incidentAnalysisComment: z.string(),
  incidentDescription: z.record(z.string(), z.string()),
  incidentDescriptionPublic: z.boolean(),
  incidentLede: z.record(z.string(), z.string()),
  incidentLedePublic: z.boolean(),
  involvementsFatalitiesBurials: zIncidentsInvolvementsFatalitiesBurials,
  latitude: z.number(),
  lineCoordinatesText: z.string(),
  location: z.string(),
  locationAccuracy: zIncidentsLocationAccuracy,
  longitude: z.number(),
  multipleAvalanches: zIncidentsBedSurfaceStepped,
  municipality: z.string(),
  natural: zIncidentsNatural,
  otherDamages: zIncidentsBedSurfaceStepped,
  otherDamagesComment: z.string(),
  person: zIncidentsPerson,
  personInvolvement: zIncidentsPersonInvolvement,
  polygonCoordinatesText: z.string(),
  privateExternalDatabaseLinks: z.string(),
  privateExternalLinks: z.string(),
  publicAvalancheWarningService: z.string(),
  publicAvalancheWarningServiceOutside: z.boolean(),
  publicExternalLinks: z.string(),
  publishedAt: z.iso.datetime(),
  recentLoading: zIncidentsCriticalWarming,
  recentSlabAvalanches: zIncidentsCriticalWarming,
  region: z.string(),
  relevantAvalancheProblem: zIncidentsProblemType,
  remoteTriggering: zIncidentsBedSurfaceStepped,
  reportStatus: zIncidentsReportStatus,
  signsOfInstability: zIncidentsCriticalWarming,
  slabWidth: z.number(),
  snowpackDescription: z.record(z.string(), z.string()),
  snowpackDescriptionPublic: z.boolean(),
  sourceOfInformation: z.array(z.string()),
  startZoneAspect: zIncidentsStartZoneAspect,
  startZoneAspectAccuracy: zIncidentsStartZoneAspectAccuracy,
  startZoneElevation: z.number(),
  startZoneElevationAccuracy: zIncidentsStartZoneElevationAccuracy,
  startZoneIncline: z.number(),
  startZoneMoisture: zIncidentsStartZoneMoisture,
  startZoneTerrainType: z.array(z.string()),
  takeAways: z.record(z.string(), z.string()),
  takeAwaysPublic: z.boolean(),
  timeAccuracy: zIncidentsTimeAccuracy,
  trigger: z.string(),
  updatedAt: z.iso.datetime(),
  vehicle: z.string(),
  victimInformation: z.array(zIncidentsVictimInformation),
  weakLayerGrainSize1: z.number(),
  weakLayerGrainSize2: z.number(),
  weakLayerGrainType1: zIncidentsWeakLayerGrainType,
  weakLayerGrainType2: zIncidentsWeakLayerGrainType,
  weakLayerLocation: zIncidentsWeakLayerLocation,
  weakLayerName: z.string(),
  weatherDescription: z.record(z.string(), z.string()),
  weatherDescriptionPublic: z.boolean(),
});

/**
 * The enum contains the ISO 639-1 codes for available languages.
 */
export const zLanguageCode = z
  .enum(["de", "it", "en", "fr", "es", "ca", "oc"])
  .describe("The enum contains the ISO 639-1 codes for available languages.");

export const zAvalancheBulletinText = z.object({
  languageCode: zLanguageCode,
  text: z.string(),
});

export const zLocalServerInstance = z.object({
  publishAt5PM: z.boolean(),
  publishAt8AM: z.boolean(),
  mapsPath: z.string(),
  mapProductionUrl: z.string(),
  pdfDirectory: z.string(),
  htmlDirectory: z.string(),
  mediaPath: z.string(),
});

export const zNaturalAvalancheReleaseProbability = z.enum(["one", "two", "three", "four"]);

export const zMatrixInformation = z.object({
  artificialDangerRating: zDangerRating.optional(),
  artificialAvalancheSize: zAvalancheSize.optional(),
  artificialAvalancheReleaseProbability: zArtificialAvalancheReleaseProbability.optional(),
  artificialHazardSiteDistribution: zHazardSiteDistribution.optional(),
  naturalDangerRating: zDangerRating.optional(),
  naturalAvalancheReleaseProbability: zNaturalAvalancheReleaseProbability.optional(),
  naturalHazardSiteDistribution: zHazardSiteDistribution.optional(),
});

export const zPasskeyServiceAssertionResponse = z.object({
  clientDataJSON: z.string(),
  authenticatorData: z.string(),
  signature: z.string(),
  userHandle: z.string().nullish(),
});

export const zPasskeyServiceAttestationResponse = z.object({
  clientDataJSON: z.string(),
  attestationObject: z.string(),
});

export const zPasskeyServiceAuthenticationCredential = z.object({
  id: z.string(),
  type: z.string(),
  response: zPasskeyServiceAssertionResponse,
});

export const zPasskeyServiceAuthenticatorSelection = z.object({
  residentKey: z.string(),
  userVerification: z.string(),
});

export const zPasskeyServiceCredentialDescriptor = z.object({
  type: z.string(),
  id: z.string(),
});

export const zPasskeyServiceLoginBeginRequest = z.object({
  username: z.string().nullish(),
});

export const zPasskeyServiceLoginFinishRequest = z.object({
  state: z.string(),
  credential: zPasskeyServiceAuthenticationCredential,
});

/**
 * What a passkey management UI needs to show --- never the credential ID or public key.
 */
export const zPasskeyServicePasskeyInfo = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    createdAt: z.iso.datetime(),
    lastUsedAt: z.iso.datetime().nullish(),
  })
  .describe("What a passkey management UI needs to show --- never the credential ID or public key.");

export const zPasskeyServicePubKeyCredParam = z.object({
  type: z.string(),
  alg: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" })
    .max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }),
});

export const zPasskeyServicePublicKeyCredentialRequestOptions = z.object({
  challenge: z.string(),
  rpId: z.string(),
  allowCredentials: z.array(zPasskeyServiceCredentialDescriptor),
  userVerification: z.string(),
  timeout: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" })
    .max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }),
});

export const zPasskeyServiceLoginChallenge = z.object({
  state: z.string(),
  publicKey: zPasskeyServicePublicKeyCredentialRequestOptions,
});

export const zPasskeyServiceRegistrationCredential = z.object({
  id: z.string(),
  type: z.string(),
  response: zPasskeyServiceAttestationResponse,
});

export const zPasskeyServiceRegisterFinishRequest = z.object({
  state: z.string(),
  credential: zPasskeyServiceRegistrationCredential,
  name: z.string().nullish(),
});

export const zPasskeyServiceRelyingParty = z.object({
  id: z.string(),
  name: z.string(),
});

export const zPasskeyServiceUserEntity = z.object({
  id: z.string(),
  name: z.string(),
  displayName: z.string(),
});

export const zPasskeyServicePublicKeyCredentialCreationOptions = z.object({
  challenge: z.string(),
  rp: zPasskeyServiceRelyingParty,
  user: zPasskeyServiceUserEntity,
  pubKeyCredParams: z.array(zPasskeyServicePubKeyCredParam),
  authenticatorSelection: zPasskeyServiceAuthenticatorSelection,
  attestation: z.string(),
  excludeCredentials: z.array(zPasskeyServiceCredentialDescriptor),
  timeout: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" })
    .max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }),
});

export const zPasskeyServiceRegistrationChallenge = z.object({
  state: z.string(),
  publicKey: zPasskeyServicePublicKeyCredentialCreationOptions,
});

export const zPosition = z.enum(["topleft", "topright", "bottomleft", "bottomright"]);

export const zProbability = z.enum(["likely", "possible", "unlikely"]);

export const zPublicationChecklistItem = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    publicationChannel: z.string().optional(),
    ok: z.boolean().optional(),
    problemDescription: z.string().optional(),
  }),
);

export const zChecklistServiceChecklist = z.object({
  checklistId: z.string(),
  timestamp: z.iso.datetime(),
  checklistItems: z.array(zPublicationChecklistItem),
  user: z.string(),
});

export const zPublicationStrategyType = z.enum(["publish", "noMessages", "minimalCAAML"]);

export const zPushSubscription = z.object({
  id: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" })
    .max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" })
    .nullish(),
  subscribeDate: z.iso.datetime().optional(),
  auth: z.string().optional(),
  p256dh: z.string().optional(),
  endpoint: z.string().optional(),
  language: zLanguageCode.optional(),
  region: z.string().optional(),
  failedCount: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
});

export const zRecognizability = z.enum(["very_easy", "easy", "hard", "very_hard"]);

export const zRegionLanguageConfiguration = z.object({
  lang: zLanguageCode.optional(),
  websiteName: z.string().describe("Website name").optional(),
  warningServiceName: z.string().describe("Warning service name").optional(),
  warningServiceEmail: z.string().describe("Warning service email").optional(),
  url: z.string().describe("Website URL").optional(),
  urlWithDate: z.string().describe("Website URL for date given by %s").optional(),
});

export const zRole = z.enum(["SUPERADMIN", "ADMIN", "FORECASTER", "FOREMAN", "OBSERVER"]);

/**
 * This class holds all information about a server instance.
 */
export const zServerInstance = z
  .object({
    id: z.coerce
      .bigint()
      .min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" })
      .max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" })
      .nullish(),
    name: z.string().optional(),
    apiUrl: z.string().optional(),
    userName: z.string().optional(),
    password: z.string().optional(),
    externalServer: z.boolean().optional(),
  })
  .describe("This class holds all information about a server instance.");

export const zServerInstanceServiceServerVersionInfo = z.object({
  version: z.string(),
});

export const zSlopeGradient = z.enum(["moderately_steep", "steep", "very_steep", "extremely_steep"]);

export const zSnowpackPosition = z.enum(["upper", "middle", "lower", "ground"]);

export const zSnowpackStability = z.enum(["good", "fair", "poor", "very_poor"]);

export const zEawsMatrixInformation = z.object({
  dangerRating: zDangerRating.optional(),
  dangerRatingModificator: zDangerRatingModificator.optional(),
  avalancheSize: zAvalancheSize.optional(),
  snowpackStability: zSnowpackStability.optional(),
  frequency: zFrequency.optional(),
  avalancheSizeValue: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
  snowpackStabilityValue: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
  frequencyValue: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
});

export const zAvalancheProblem = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    avalancheType: zAvalancheType.optional(),
    avalancheProblem: zAvalancheProblem1.optional(),
    aspects: z.array(zAspect).optional(),
    elevationHigh: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    treelineHigh: z.boolean().optional(),
    elevationLow: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    treelineLow: z.boolean().optional(),
    dangerRatingDirection: zDirection.optional(),
    matrixInformation: zMatrixInformation.optional(),
    eawsMatrixInformation: zEawsMatrixInformation.optional(),
  }),
);

export const zAvalancheBulletinDaytimeDescription = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    warningLevelId: z.string().optional(),
    hasElevationDependency: z.boolean().optional(),
    elevation: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    treeline: z.boolean().optional(),
    dangerRatingAbove: zDangerRating.optional(),
    dangerRatingBelow: zDangerRating.optional(),
    complexity: zComplexity.optional(),
    avalancheProblem1: zAvalancheProblem.nullish(),
    avalancheProblem2: zAvalancheProblem.nullish(),
    avalancheProblem3: zAvalancheProblem.nullish(),
    avalancheProblem4: zAvalancheProblem.nullish(),
    avalancheProblem5: zAvalancheProblem.nullish(),
  }),
);

export const zStatusInformation = z.object({
  ok: z.boolean(),
  title: z.string(),
  message: z.string(),
});

export const zStrategicMindset = z.enum([
  "assessment",
  "stepping_out",
  "status_quo",
  "stepping_back",
  "entrenchment",
  "free_ride",
  "high_alert",
  "spring_diurnal",
]);

export const zStressLevel = z.object({
  date: z.iso.date().optional(),
  stressLevel: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
  lastUpdated: z.iso.datetime().optional(),
});

export const zSubscriptionServiceEmailSubscription = z.object({
  email: z.string(),
  regions: z.string(),
  language: zLanguageCode,
});

export const zTendency = z.enum(["decreasing", "steady", "increasing"]);

export const zTendencyProgression = z.object({
  dates: z.array(z.iso.datetime()).describe("Start dates of the bulletins of the preceding days").optional(),
  dangerRatings: z
    .record(z.string(), z.array(zDangerRating))
    .describe("Highest danger rating of each of these days, per micro region")
    .optional(),
});

export const zTerrainType = z.enum([
  "gullies_and_bowls",
  "adjacent_to_ridgelines",
  "distant_from_ridgelines",
  "in_the_vicinity_of_peaks",
  "pass_areas",
  "shady_slopes",
  "sunny_slopes",
  "grassy_slopes",
  "cut_slopes",
  "wind_loaded_slopes",
  "base_of_rock_walls",
  "behind_abrupt_changes_in_the_terrain",
  "transitions_into_gullies_and_bowls",
  "areas_where_the_snow_cover_is_rather_shallow",
  "transitions_from_a_shallow_to_a_deep_snowpack",
  "highly_frequented_off_piste_terrain",
  "little_used_backcountry_terrain",
  "places_that_are_protected_from_the_wind",
  "regions_exposed_to_the_foehn_wind",
  "regions_with_a_lot_of_snow",
  "regions_exposed_to_precipitation",
  "regions_exposed_to_heavier_precipitation",
]);

export const zTextPart = z.enum([
  "generalHeadlineComment",
  "highlights",
  "avActivityHighlights",
  "avActivityComment",
  "snowpackStructureHighlights",
  "snowpackStructureComment",
  "synopsisHighlights",
  "synopsisComment",
  "tendencyComment",
  "travelAdvisoryHighlights",
  "travelAdvisoryComment",
]);

/**
 * This class holds all information about one region.
 */
export const zRegion = z
  .object({
    id: z.string().describe("Region ID").optional(),
    microRegions: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .describe("Number of micro regions")
      .optional(),
    subRegions: z.array(z.string()).describe("ID of sub regions").optional(),
    superRegions: z.array(z.string()).describe("ID of super regions").optional(),
    neighborRegions: z.array(z.string()).describe("ID of neighbouring regions").optional(),
    languageConfigurations: z.array(zRegionLanguageConfiguration).describe("Language configuration").optional(),
    staticUrl: z.string().describe("URL to static avalanche files").optional(),
    enabledLanguages: z.array(zLanguageCode).describe("Enabled languages").optional(),
    ttsLanguages: z.array(zLanguageCode).describe("Text-to-speech languages").optional(),
    publishBulletins: z.boolean().describe("Publish avalanche forecast").optional(),
    publishBlogs: z.boolean().describe("Publish blog posts").optional(),
    createCaamlV6: z.boolean().describe("Create CAAML v6").optional(),
    createJson: z.boolean().describe("Create JSON").optional(),
    createMaps: z.boolean().describe("Create maps").optional(),
    createPdf: z.boolean().describe("Create PDF").optional(),
    createSimpleHtml: z.boolean().describe("Create simple HTML").optional(),
    sendEmails: z.boolean().describe("Send emails").optional(),
    sendTelegramMessages: z.boolean().describe("Send telegram messages").optional(),
    sendWhatsAppMessages: z.boolean().describe("Send WhatsApp messages").optional(),
    sendPushNotifications: z.boolean().describe("Send push notifications").optional(),
    enableMediaFile: z.boolean().describe("Enable media file").optional(),
    enableIcon: z.boolean().describe("Enable weather").optional(),
    enableAvalancheProblemCornices: z.boolean().describe("Enable avalanche problem CORNICES").optional(),
    enableAvalancheProblemNoDistinctAvalancheProblem: z
      .boolean()
      .describe("Enable avalanche problem NO DISTINCT AVALANCHE PROBLEM")
      .optional(),
    showMatrix: z.boolean().describe("Show matrix").optional(),
    enableStrategicMindset: z.boolean().describe("Enable strategic mindset").optional(),
    enableStressLevel: z.boolean().describe("Enable stress level").optional(),
    pdfColor: z.string().describe("PDF color").optional(),
    emailColor: z.string().describe("Email color").optional(),
    pdfMapYAmPm: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .describe("Y for PDF map (am/pm)")
      .optional(),
    pdfMapYFd: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .describe("Y for PDF map (fd)")
      .optional(),
    pdfMapWidthAmPm: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .describe("Map width for PDF (am/pm)")
      .optional(),
    pdfMapWidthFd: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .describe("Map width for PDF (fd)")
      .optional(),
    pdfMapHeight: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .describe("Map height for PDF")
      .optional(),
    pdfFooterLogo: z.boolean().describe("Logo for PDF footer").optional(),
    pdfFooterLogoColorPath: z.string().describe("Logo for PDF footer (color)").optional(),
    pdfFooterLogoBwPath: z.string().describe("Logo for PDF footer (bw)").optional(),
    geoDataDirectory: z.string().describe("Geodata directory").optional(),
    mapLogoPosition: zPosition.optional(),
    imageColorbarColorPath: z.string().describe("Colorbar (color)").optional(),
    imageColorbarBwPath: z.string().describe("Colorbar (b/w)").optional(),
    enableDangerSources: z.boolean().describe("Enable danger sources").optional(),
    enableObservations: z.boolean().describe("Enable observations").optional(),
    enableIncidents: z.boolean().describe("Enable incidents").optional(),
    enableModelling: z.boolean().describe("Enable modelling").optional(),
    enabledTextcatFields: z
      .array(zTextPart)
      .describe("Textfields for bulletins to be entered using textcat")
      .optional(),
    enabledEditableFields: z
      .array(zTextPart)
      .describe("Editable textfields instead of textcat for bulletins")
      .optional(),
    enableLineaExport: z.boolean().describe("Enable LINEA export").optional(),
    defaultLang: zLanguageCode.optional(),
    logoPath: z.string().describe("Logo for PDF (color)").optional(),
    logoBwPath: z.string().describe("Logo for PDF (bw)").optional(),
    coatOfArms: z.string().describe("Image URL for coat of arms").optional(),
    serverImagesUrl: z.string().describe("URL to server images").optional(),
    educationUrl: z.string().describe("URL to education content").optional(),
    awsomeUrl: z.string().describe("URL to AWSOME modelling configuration").optional(),
  })
  .describe("This class holds all information about one region.");

export const zThickness = z.enum(["thick", "thin"]);

export const zUser = z.object({
  email: z.string().describe("Email address of the user").optional(),
  password: z.string().describe("Password of the user").optional(),
  name: z.string().describe("Name of the user").optional(),
  roles: z.array(zRole).optional(),
  regions: z.array(z.string()).optional(),
  image: z.string().describe("Image of the user").optional(),
  organization: z.string().describe("Organization the user works for").optional(),
  languageCode: zLanguageCode.optional(),
  deleted: z.boolean().optional(),
  lastUsedAt: z.iso.datetime().describe("When the user last logged in, whether by password or passkey").optional(),
});

export const zAuthenticationServiceAuthenticationResponse = z.object({
  user: zUser,
  regions: z.array(zRegion),
  access_token: z.string(),
});

/**
 * This class holds all information about one avalanche bulletin.
 */
export const zAvalancheBulletin = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    author: zUser.nullish(),
    additionalAuthors: z.array(z.string()).optional(),
    updateDate: z.iso.datetime().optional(),
    ownerRegion: z.string().optional(),
    highlightsTextcat: z.string().optional(),
    avActivityHighlightsTextcat: z.string().optional(),
    avActivityCommentTextcat: z.string().optional(),
    snowpackStructureHighlightsTextcat: z.string().optional(),
    snowpackStructureCommentTextcat: z.string().optional(),
    tendencyCommentTextcat: z.string().optional(),
    generalHeadlineCommentTextcat: z.string().optional(),
    synopsisCommentTextcat: z.string().optional(),
    avActivityHighlightsNotes: z.string().optional(),
    avActivityCommentNotes: z.string().optional(),
    snowpackStructureHighlightsNotes: z.string().optional(),
    snowpackStructureCommentNotes: z.string().optional(),
    tendencyCommentNotes: z.string().optional(),
    generalHeadlineCommentNotes: z.string().optional(),
    highlights: z.array(zAvalancheBulletinText).optional(),
    avActivityHighlights: z.array(zAvalancheBulletinText).optional(),
    avActivityComment: z.array(zAvalancheBulletinText).optional(),
    synopsisHighlights: z.array(zAvalancheBulletinText).optional(),
    synopsisComment: z.array(zAvalancheBulletinText).optional(),
    snowpackStructureHighlights: z.array(zAvalancheBulletinText).optional(),
    snowpackStructureComment: z.array(zAvalancheBulletinText).optional(),
    travelAdvisoryHighlights: z.array(zAvalancheBulletinText).optional(),
    travelAdvisoryComment: z.array(zAvalancheBulletinText).optional(),
    tendencyComment: z.array(zAvalancheBulletinText).optional(),
    generalHeadlineComment: z.array(zAvalancheBulletinText).optional(),
    tendency: zTendency.optional(),
    dangerPattern1: zDangerPattern.optional(),
    dangerPattern2: zDangerPattern.optional(),
    publicationDate: z.iso.datetime().optional(),
    validity: zAvalancheBulletinValidity.optional(),
    suggestedRegions: z.array(z.string()).describe("The recommended regions the avalanche bulletin is for.").optional(),
    savedRegions: z.array(z.string()).describe("The saved regions the avalanche bulletin is for.").optional(),
    savedOrPublishedRegions: z.array(z.string()).optional(),
    regions: z.array(z.string()).optional(),
    publishedRegions: z.array(z.string()).describe("The published regions the avalanche bulletin is for.").optional(),
    strategicMindset: zStrategicMindset.optional(),
    forenoon: zAvalancheBulletinDaytimeDescription.nullish(),
    afternoon: zAvalancheBulletinDaytimeDescription.nullish(),
    photos: z.array(zAvalancheBulletinPhoto).describe("Collection containing all photos of a bulletin").optional(),
    hasDaytimeDependency: z.boolean().optional(),
  }),
);

export const zUserServiceChangePassword = z.object({
  oldPassword: z.string(),
  newPassword: z.string(),
});

export const zUserServiceCheckPassword = z.object({
  password: z.string(),
});

export const zUserServiceResetPassword = z.object({
  newPassword: z.string(),
});

export const zWeatherStationsFeatureType = z.enum(["Feature"]);

export const zWeatherStationsFeatureCollectionType = z.enum(["FeatureCollection"]);

export const zWeatherStationsGeometryType = z.enum(["Point"]);

export const zWeatherStationsGeometry = z.object({
  coordinates: z.array(z.number()).describe("Longitude, latitude and (optionally) altitude").optional(),
  type: zWeatherStationsGeometryType,
});

export const zWeatherStationsStatistics = z.object({
  average: z.number(),
  count: z.number(),
  delta: z.number(),
  max: z.number(),
  median: z.number(),
  min: z.number(),
  sum: z.number(),
  unit: z
    .enum(["K", "℃", "m", "cm", "mm", "1", "%", "°", "m/s", "km/h", "hPa", "Pa", "W/m²"])
    .describe("Unit of the measured values")
    .optional(),
});

/**
 * The properties of a weather station including measured values
 */
export const zWeatherStationsProperties = z
  .object({
    altitude: z
      .number()
      .describe("Altitude above sea level (alternatively specify 3rd component in coordinates)")
      .optional(),
    dataProviderID: z.string(),
    dataURLs: z
      .array(z.string())
      .describe(
        "Data URLs for this station (typically SMET format is used, and three URLs are provided, short term, winter season, all winter seasons)",
      )
      .optional(),
    date: z.iso.datetime().describe("ISO 8601 timestamp").optional(),
    DW: z.number().describe("Wind direction (optionally average over the last 3h) in °").optional(),
    HS: z.number().describe("Snow height in m").optional(),
    HSD_24: z.number().describe("Difference in snow height over the last 24h in m").optional(),
    HSD_48: z.number().describe("Difference in snow height over the last 48h in m").optional(),
    HSD_6: z.number().describe("Difference in snow height over the last 6h in m").optional(),
    HSD_72: z.number().describe("Difference in snow height over the last 72h in m").optional(),
    ILWR: z.number().describe("Incoming Long Wave Radiation in W/m²").optional(),
    ISWR: z.number().describe("Incoming Short Wave Radiation in W/m²").optional(),
    microRegionID: z.string().describe("EAWS micro region ID, see https://gitlab.com/eaws/eaws-regions").optional(),
    name: z.string().describe("Station name").optional(),
    OLWR: z.number().describe("Outgoing Long Wave Radiation in W/m²").optional(),
    operator: z.string().describe("Station operator").optional(),
    operatorLicense: z.string().describe("License under which data is provided").optional(),
    operatorLicenseLink: z.url().describe("Link to license").optional(),
    operatorLink: z.url().describe("Link to website of station operator").optional(),
    P: z.number().describe("Air pressure in Pa").optional(),
    plot: z.string().describe("For legacy PNG plots: name of plot which includes this station").optional(),
    PSUM_24: z.number().describe("Precipitation summed over the last 24h in mm").optional(),
    PSUM_48: z.number().describe("Precipitation summed over the last 48h in mm").optional(),
    PSUM_6: z.number().describe("Precipitation summed over the last 6h in mm").optional(),
    PSUM_72: z.number().describe("Precipitation summed over the last 72h in mm").optional(),
    RH: z.number().describe("Relative humidity between 0 and 1").optional(),
    RSWR: z.number().describe("Reflected Short Wave Radiation in W/m²").optional(),
    shortName: z
      .string()
      .regex(/^[A-Za-z0-9]+$/)
      .describe("Station short name (such as ISEE2) consisting of [A-Za-z0-9] only")
      .optional(),
    startYear: z.string().describe("Observation start year").optional(),
    stationCharacteristics: z
      .string()
      .describe("A few sentences describing the station characteristics/locality/history/...")
      .optional(),
    statistics: z.record(z.string(), zWeatherStationsStatistics),
    TA: z.number().describe("Air temperature in Kelvin").optional(),
    TA_MAX: z.number().describe("Max. air temperature over the last 24h in Kelvin").optional(),
    TA_MIN: z.number().describe("Min. air temperature over the last 24h in Kelvin").optional(),
    TD: z.number().describe("Dew point temperature in Kelvin").optional(),
    TSS: z.number().describe("Temperature Snow Surface in Kelvin").optional(),
    VW: z.number().describe("Wind velocity (optionally as average over the last 3h) in m/s").optional(),
    VW_MAX: z.number().describe("Max. wind velocity (optionally max over the last 3h) in m/s").optional(),
  })
  .describe("The properties of a weather station including measured values");

/**
 * A GeoJSON Feature corresponding to one weather station
 */
export const zWeatherStationsFeature = z
  .object({
    geometry: zWeatherStationsGeometry,
    id: z.string().describe("The ID/UUID of the station").optional(),
    properties: zWeatherStationsProperties,
    type: zWeatherStationsFeatureType,
  })
  .describe("A GeoJSON Feature corresponding to one weather station");

/**
 * A GeoJSON FeatureCollection of weather stations
 */
export const zWeatherStationsFeatureCollection = z
  .object({
    features: z.array(zWeatherStationsFeature),
    properties: z.record(z.string(), z.unknown()),
    type: zWeatherStationsFeatureCollectionType,
  })
  .describe("A GeoJSON FeatureCollection of weather stations");

export const zWetness = z.enum(["wet", "moist", "dry"]);

/**
 * This class holds all information about one danger source variant.
 */
export const zDangerSourceVariant = zAbstractPersistentObject.and(
  z.object({
    id: z.string().nullish(),
    originalDangerSourceVariantId: z.string().optional(),
    forecastDangerSourceVariantId: z.string().optional(),
    dangerSource: zDangerSource.nullish(),
    title: z.string().optional(),
    creationDate: z.iso.datetime().optional(),
    updateDate: z.iso.datetime().optional(),
    validFrom: z.iso.datetime().describe("Validity of the danger source variant.").optional(),
    validUntil: z.iso.datetime().optional(),
    dangerSourceVariantStatus: zDangerSourceVariantStatus.optional(),
    dangerSourceVariantType: zDangerSourceVariantType.optional(),
    ownerRegion: z.string().optional(),
    regions: z.array(z.string()).describe("The regions where the danger source variant is present.").optional(),
    hasDaytimeDependency: z.boolean().optional(),
    avalancheType: zAvalancheType.optional(),
    aspects: z.array(zAspect).optional(),
    elevationHigh: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    treelineHigh: z.boolean().optional(),
    elevationLow: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    treelineLow: z.boolean().optional(),
    aspectsOfExistence: z.array(zAspect).optional(),
    elevationHighOfExistence: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    treelineHighOfExistence: z.boolean().optional(),
    elevationLowOfExistence: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    treelineLowOfExistence: z.boolean().optional(),
    dangerIncreaseWithElevation: z.boolean().optional(),
    highestDangerAspect: zAspect.optional(),
    dangerPeak: zDaytime.optional(),
    slopeGradient: zSlopeGradient.optional(),
    runoutIntoGreen: z.boolean().optional(),
    penetrateDeepLayers: z.boolean().optional(),
    naturalRelease: zProbability.optional(),
    dangerSigns: z.array(zDangerSign).optional(),
    eawsMatrixInformation: zEawsMatrixInformation.optional(),
    comment: z.string().optional(),
    textcat: z.string().optional(),
    uncertainty: z.string().optional(),
    glidingSnowActivity: zGlidingSnowActivity.optional(),
    glidingSnowActivityValue: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    snowHeightUpperLimit: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    snowHeightLowerLimit: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    snowHeightAverage: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    zeroDegreeIsotherm: z.boolean().optional(),
    slabGrainShape: zGrainShape.optional(),
    slabThicknessUpperLimit: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    slabThicknessLowerLimit: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    slabHandHardnessUpperLimit: zHandHardness.optional(),
    slabHandHardnessLowerLimit: zHandHardness.optional(),
    slabHardnessProfile: zTendency.optional(),
    slabEnergyTransferPotential: zCharacteristic.optional(),
    slabDistribution: zDistribution.optional(),
    weakLayerGrainShapes: z.array(zGrainShape).optional(),
    weakLayerGrainSizeUpperLimit: z.number().optional(),
    weakLayerGrainSizeLowerLimit: z.number().optional(),
    weakLayerPersistent: z.boolean().optional(),
    weakLayerThickness: zThickness.optional(),
    weakLayerStrength: zCharacteristic.optional(),
    weakLayerWet: z.boolean().optional(),
    weakLayerCrustAbove: zCrust.optional(),
    weakLayerCrustBelow: zCrust.optional(),
    weakLayerPosition: zSnowpackPosition.optional(),
    weakLayerCreation: zCreationProcess.optional(),
    weakLayerDistribution: zDistribution.optional(),
    dangerSpotRecognizability: zRecognizability.optional(),
    remoteTriggering: zProbability.optional(),
    terrainTypes: z.array(zTerrainType).optional(),
    looseSnowGrainShape: zGrainShape.optional(),
    looseSnowMoisture: zWetness.optional(),
  }),
);

/**
 * Date of validity in the format yyyy-MM-dd
 */
export const zStaticDate = z.iso.date().describe("Date of validity in the format yyyy-MM-dd");

/**
 * Timestamp of the hourly snapshot in the format yyyy-MM-dd_HH-mm
 */
export const zStaticDateTime = z.string().describe("Timestamp of the hourly snapshot in the format yyyy-MM-dd_HH-mm");

/**
 * Publication timestamp in the format yyyy-MM-dd_HH-mm-ss
 */
export const zStaticPublication = z.string().describe("Publication timestamp in the format yyyy-MM-dd_HH-mm-ss");

/**
 * Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`
 */
export const zStaticRegion = z.string().describe("Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`");

export const zStaticLang = zLanguageCode;

/**
 * index 200 response
 */
export const zIndexResponse = z.string().describe("index 200 response");

export const zLoginBody = zAuthenticationServiceCredentials;

/**
 * login 200 response
 */
export const zLoginResponse = zAuthenticationServiceAuthenticationResponse;

/**
 * listPasskeys 200 response
 */
export const zListPasskeysResponse = z.array(zPasskeyServicePasskeyInfo).describe("listPasskeys 200 response");

export const zFinishLoginBody = zPasskeyServiceLoginFinishRequest;

/**
 * finishLogin 200 response
 */
export const zFinishLoginResponse = zAuthenticationServiceAuthenticationResponse;

export const zBeginLoginBody = zPasskeyServiceLoginBeginRequest;

/**
 * beginLogin 200 response
 */
export const zBeginLoginResponse = zPasskeyServiceLoginChallenge;

export const zFinishRegistrationBody = zPasskeyServiceRegisterFinishRequest;

/**
 * finishRegistration 200 response
 */
export const zFinishRegistrationResponse = zPasskeyServicePasskeyInfo;

/**
 * beginRegistration 200 response
 */
export const zBeginRegistrationResponse = zPasskeyServiceRegistrationChallenge;

export const zDeletePasskeyPath = z.object({
  id: z.string(),
});

/**
 * testAuth 200 response
 */
export const zTestAuthResponse = zAuthenticationServiceUsername;

export const zGetBlogPostQuery = z.object({
  region: z.string().optional().default("AT-07"),
  lang: zLanguageCode.optional(),
  id: z.string(),
});

/**
 * getBlogPost 200 response
 */
export const zGetBlogPostResponse = zBlogItem;

export const zGetBlogPostsQuery = z.object({
  region: z.string().optional().default("AT-07"),
  lang: zLanguageCode.optional(),
  searchText: z.string(),
  searchCategory: z.string(),
  startDate: z.string(),
  endDate: z.string(),
});

/**
 * getBlogPosts 200 response
 */
export const zGetBlogPostsResponse = z.array(zBlogItem).describe("getBlogPosts 200 response");

export const zSendLatestBlogPostQuery = z.object({
  region: z.string(),
  lang: zLanguageCode,
});

export const zSendLatestBlogPostEmailQuery = z.object({
  region: z.string(),
  lang: zLanguageCode,
});

export const zSendLatestBlogPostPushQuery = z.object({
  region: z.string(),
  lang: zLanguageCode,
});

export const zSendLatestBlogPostTelegramQuery = z.object({
  region: z.string(),
  lang: zLanguageCode,
});

export const zSendLatestBlogPostWhatsAppQuery = z.object({
  region: z.string(),
  lang: zLanguageCode,
});

export const zGetPublishedJsonBulletins0Query = z.object({
  version: zCaamlVersion.optional(),
  regions: z.array(z.string()),
  region: z.string(),
  lang: zLanguageCode,
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * bulletins
 */
export const zGetPublishedJsonBulletins0Response = z.array(zAvalancheBulletin).describe("bulletins");

export const zCreateJsonBulletinsBody = z.array(zAvalancheBulletin);

export const zCreateJsonBulletinsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * createJSONBulletins 200 response
 */
export const zCreateJsonBulletinsResponse = z.array(zAvalancheBulletin).describe("createJSONBulletins 200 response");

export const zCreateJsonBulletinBody = zAvalancheBulletin;

export const zCreateJsonBulletinQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * createJSONBulletin 200 response
 */
export const zCreateJsonBulletinResponse = z.array(zAvalancheBulletin).describe("createJSONBulletin 200 response");

export const zGetPublishedCaamlBulletinsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  regions: z.array(z.string()),
  lang: zLanguageCode.optional(),
  version: zCaamlVersion.optional(),
});

/**
 * CAAML XML bulletins
 */
export const zGetPublishedCaamlBulletinsResponse = zCaamlAvalancheBulletins;

export const zGetPublishedCaamlJsonBulletinsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  regions: z.array(z.string()),
  lang: zLanguageCode,
  version: zCaamlVersion.optional(),
});

/**
 * CAAML JSON bulletins
 */
export const zGetPublishedCaamlJsonBulletinsResponse = zCaamlAvalancheBulletins;

export const zCheckBulletinsQuery = z.object({
  region: z.string(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * checkBulletins 200 response
 */
export const zCheckBulletinsResponse = z.array(z.string()).describe("checkBulletins 200 response");

export const zGetJsonBulletinsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  regions: z.array(z.string()),
});

/**
 * bulletins
 */
export const zGetJsonBulletinsResponse = z.array(zAvalancheBulletin).describe("bulletins");

export const zGetCaamlJsonBulletinsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  regions: z.array(z.string()),
  lang: zLanguageCode,
  version: zCaamlVersion.optional(),
});

/**
 * CAAML JSON bulletins
 */
export const zGetCaamlJsonBulletinsResponse = zCaamlAvalancheBulletins;

export const zGetHighestDangerRatingQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  regions: z.array(z.string()),
});

/**
 * latest
 */
export const zGetHighestDangerRatingResponse = zAvalancheBulletinServiceHighest;

export const zGetPublishedJsonBulletinsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  regions: z.array(z.string()),
  lang: zLanguageCode,
});

/**
 * bulletins
 */
export const zGetPublishedJsonBulletinsResponse = z.array(zAvalancheBulletin).describe("bulletins");

/**
 * getLatest 200 response
 */
export const zGetLatestResponse = zAvalancheBulletinServiceLatestBulletin;

export const zGetPublishedBulletinsAsPdfQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  bulletinId: z.string().nullish(),
  microRegionId: z.string().nullish(),
  region: z.string(),
  grayscale: z.boolean(),
  lang: zLanguageCode,
});

/**
 * getPublishedBulletinsAsPDF 200 response
 */
export const zGetPublishedBulletinsAsPdfResponse = z.string().describe("getPublishedBulletinsAsPDF 200 response");

export const zUploadBulletinPhotoBody = z.object({
  file: z.string().optional(),
});

export const zUploadBulletinPhotoQuery = z.object({
  region: z.string(),
});

/**
 * uploadBulletinPhoto 200 response
 */
export const zUploadBulletinPhotoResponse = zCaamlAvalancheBulletinCustomDataBulletinPhoto;

export const zGetPreviewPdfBody = z.array(zAvalancheBulletin);

export const zGetPreviewPdfQuery = z.object({
  region: z.string(),
  lang: zLanguageCode,
});

/**
 * getPreviewPdf 200 response
 */
export const zGetPreviewPdfResponse = z.string().describe("getPreviewPdf 200 response");

export const zPublishBulletinsQuery = z.object({
  region: z.string(),
  strategy: zPublicationStrategyType.optional(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

export const zPublishAllBulletinsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  strategy: zPublicationStrategyType.optional(),
});

export const zSendEmailQuery = z.object({
  region: z.string(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  lang: zLanguageCode.nullish(),
});

export const zTriggerPushNotificationsQuery = z.object({
  region: z.string(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  lang: zLanguageCode.nullish(),
});

export const zTriggerTelegramChannelQuery = z.object({
  region: z.string(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  lang: zLanguageCode.nullish(),
});

export const zTriggerWhatsAppChannelQuery = z.object({
  region: z.string(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  lang: zLanguageCode.nullish(),
});

export const zGetStatusQuery = z.object({
  region: z.string(),
  timezone: z.string(),
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getStatus 200 response
 */
export const zGetStatusResponse = z.array(zAvalancheBulletinStatusServiceStatus).describe("getStatus 200 response");

export const zGetInternalStatusQuery = z.object({
  region: z.string(),
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getInternalStatus 200 response
 */
export const zGetInternalStatusResponse = z
  .array(zAvalancheBulletinStatusServiceStatus)
  .describe("getInternalStatus 200 response");

export const zGetPublicationStatusQuery = z.object({
  region: z.string(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getPublicationStatus 200 response
 */
export const zGetPublicationStatusResponse = zAvalancheBulletinStatusServiceStatus;

export const zSubmitBulletinsQuery = z.object({
  region: z.string(),
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

export const zGetTendencyQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string().nullish(),
});

/**
 * tendency of each micro region with published bulletins
 */
export const zGetTendencyResponse = zTendencyProgression;

export const zDeleteJsonBulletinPath = z.object({
  bulletinId: z.string(),
});

export const zDeleteJsonBulletinQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * deleteJSONBulletin 200 response
 */
export const zDeleteJsonBulletinResponse = z.array(zAvalancheBulletin).describe("deleteJSONBulletin 200 response");

export const zGetJsonBulletinPath = z.object({
  bulletinId: z.string(),
});

/**
 * bulletin
 */
export const zGetJsonBulletinResponse = zAvalancheBulletin;

export const zUpdateJsonBulletinBody = zAvalancheBulletin;

export const zUpdateJsonBulletinPath = z.object({
  bulletinId: z.string(),
});

export const zUpdateJsonBulletinQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * updateJSONBulletin 200 response
 */
export const zUpdateJsonBulletinResponse = z.array(zAvalancheBulletin).describe("updateJSONBulletin 200 response");

export const zGetChecklistsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * getChecklists 200 response
 */
export const zGetChecklistsResponse = z.array(zChecklistServiceChecklist).describe("getChecklists 200 response");

export const zSaveChecklistBody = zChecklistServiceChecklist;

export const zSaveChecklistQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * saveChecklist 200 response
 */
export const zSaveChecklistResponse = zChecklistServiceChecklist;

export const zGetDangerSourcesQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * danger-sources
 */
export const zGetDangerSourcesResponse = z.array(zDangerSource).describe("danger-sources");

export const zSaveDangerSourceBody = zDangerSource;

/**
 * saveDangerSource 200 response
 */
export const zSaveDangerSourceResponse = zDangerSource;

export const zGetVariantsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * danger-sources
 */
export const zGetVariantsResponse = z.array(zDangerSourceVariant).describe("danger-sources");

export const zGetInternalStatus1Query = z.object({
  region: z.string(),
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getInternalStatus_1 200 response
 */
export const zGetInternalStatus1Response = z
  .array(zDangerSourceVariantsStatus)
  .describe("getInternalStatus_1 200 response");

export const zSaveDangerSourceVariantBody = zDangerSourceVariant;

export const zSaveDangerSourceVariantQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * saveDangerSourceVariant 200 response
 */
export const zSaveDangerSourceVariantResponse = zDangerSourceVariant;

export const zReplaceVariantsBody = z.array(zDangerSourceVariant);

export const zReplaceVariantsQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * replaceVariants 200 response
 */
export const zReplaceVariantsResponse = z.array(zDangerSourceVariant).describe("replaceVariants 200 response");

export const zDeleteVariantPath = z.object({
  variantId: z.string(),
});

export const zDeleteVariantQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * deleteVariant 200 response
 */
export const zDeleteVariantResponse = z.array(zDangerSourceVariant).describe("deleteVariant 200 response");

export const zGetVariantByIdPath = z.object({
  variantId: z.string(),
});

/**
 * variant
 */
export const zGetVariantByIdResponse = zDangerSourceVariant;

export const zGetVariantsForDangerSourcePath = z.object({
  dangerSourceId: z.string(),
});

export const zGetVariantsForDangerSourceQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
});

/**
 * danger-sources
 */
export const zGetVariantsForDangerSourceResponse = z.array(zDangerSourceVariant).describe("danger-sources");

export const zAddSubscriberBody = zSubscriptionServiceEmailSubscription;

export const zGetIncidentsQuery = z.object({
  region: z.string(),
  seasonYear: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .describe("Season year, expanded to yyyy-10-01 until (yyyy+1)-10-01"),
  startDate: z.string().nullish(),
  endDate: z.string().nullish(),
});

/**
 * OK response
 */
export const zGetIncidentsResponse = z.array(zIncidentsIncidentSchema).describe("OK response");

export const zCreateIncidentBody = z.string();

export const zCreateIncidentQuery = z.object({
  region: z.string(),
});

/**
 * createIncident 200 response
 */
export const zCreateIncidentResponse = zIncident;

export const zDeleteIncidentPath = z.object({
  id: z.uuid(),
});

export const zGetIncidentPath = z.object({
  id: z.uuid(),
});

/**
 * OK response
 */
export const zGetIncidentResponse = zIncidentsIncidentSchema;

export const zUpdateIncidentBody = z.string();

export const zUpdateIncidentPath = z.object({
  id: z.uuid(),
});

/**
 * updateIncident 200 response
 */
export const zUpdateIncidentResponse = zIncident;

export const zUploadIncidentAttachmentBody = z.object({
  file: z.string().optional(),
});

export const zUploadIncidentAttachmentPath = z.object({
  id: z.uuid(),
});

/**
 * uploadIncidentAttachment 200 response
 */
export const zUploadIncidentAttachmentResponse = zIncidentAttachment;

export const zDeleteIncidentAttachmentPath = z.object({
  id: z.uuid(),
  attachmentId: z.uuid(),
});

export const zGetIncidentAttachmentPath = z.object({
  id: z.uuid(),
  attachmentId: z.uuid(),
});

/**
 * getIncidentAttachment 200 response
 */
export const zGetIncidentAttachmentResponse = z.string().describe("getIncidentAttachment 200 response");

export const zUnpublishIncidentPath = z.object({
  id: z.uuid(),
});

/**
 * unpublishIncident 200 response
 */
export const zUnpublishIncidentResponse = zIncident;

export const zPublishIncidentBody = z.string();

export const zPublishIncidentPath = z.object({
  id: z.uuid(),
});

/**
 * publishIncident 200 response
 */
export const zPublishIncidentResponse = zIncident;

export const zSaveMediaFileBody = z.object({
  text: z.string().optional(),
  file: z.string().optional(),
});

export const zSaveMediaFileQuery = z.object({
  date: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  region: z.string(),
  lang: zLanguageCode,
  important: z.boolean(),
});

export const zGetRssFeedQuery = z.object({
  region: z.string().optional().default("AT-07"),
  lang: zLanguageCode.optional(),
});

/**
 * getRssFeed 200 response
 */
export const zGetRssFeedResponse = z.string().describe("getRssFeed 200 response");

export const zDeleteGenericObservationBody = zGenericObservation;

export const zGetGenericObservationsQuery = z.object({
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getGenericObservations 200 response
 */
export const zGetGenericObservationsResponse = z
  .array(zGenericObservation)
  .describe("getGenericObservations 200 response");

export const zSaveOrUpdateGenericObservationBody = zGenericObservation;

export const zGetGenericObservationQuery = z.object({
  source: z.string(),
  id: z.string(),
});

/**
 * getGenericObservation 200 response
 */
export const zGetGenericObservationResponse = zGenericObservation;

/**
 * getOpenApiJson 200 response
 */
export const zGetOpenApiJsonResponse = z.record(z.string(), z.unknown()).describe("getOpenApiJson 200 response");

/**
 * getOpenApi 200 response
 */
export const zGetOpenApiResponse = z.string().describe("getOpenApi 200 response");

/**
 * key 200 response
 */
export const zKeyResponse = z.record(z.string(), z.unknown()).describe("key 200 response");

export const zSubscribeBody = zPushSubscription;

export const zUnsubscribeBody = zPushSubscription;

/**
 * getRegions 200 response
 */
export const zGetRegionsResponse = z.array(zRegion).describe("getRegions 200 response");

export const zSaveRegionBody = z.string();

/**
 * saveRegion 200 response
 */
export const zSaveRegionResponse = zRegion;

export const zGetRegionQuery = z.object({
  region: z.string(),
});

/**
 * getRegion 200 response
 */
export const zGetRegionResponse = zRegion;

/**
 * configuration
 */
export const zGetLocalServerConfigurationResponse = zLocalServerInstance;

export const zSaveServerConfigurationBody = zServerInstance;

/**
 * saveServerConfiguration 200 response
 */
export const zSaveServerConfigurationResponse = zServerInstance;

/**
 * configuration
 */
export const zGetExternalServerConfigurationsResponse = z.array(zServerInstance).describe("configuration");

/**
 * server version info
 */
export const zGetServerVersionInfoResponse = zServerInstanceServiceServerVersionInfo;

export const zGetBulletinCsvQuery = z.object({
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  lang: zLanguageCode,
  extended: z.boolean().optional().default(false),
  duplicate: z.boolean().optional().default(false),
  regions: z.array(z.string()),
  obsoleteMatrix: z.boolean().optional().default(false),
});

/**
 * getBulletinCsv 200 response
 */
export const zGetBulletinCsvResponse = z.string().describe("getBulletinCsv 200 response");

export const zGetDangerSourceCsvQuery = z.object({
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getDangerSourceCsv 200 response
 */
export const zGetDangerSourceCsvResponse = z.string().describe("getDangerSourceCsv 200 response");

export const zSaveVirtualRealityStatisticsBody = z.string();

/**
 * getStatus_1 200 response
 */
export const zGetStatus1Response = z.array(zStatusInformation).describe("getStatus_1 200 response");

/**
 * triggerStatusChecks 200 response
 */
export const zTriggerStatusChecksResponse = z.array(zStatusInformation).describe("triggerStatusChecks 200 response");

/**
 * getUsers 200 response
 */
export const zGetUsersResponse = z.array(zUser).describe("getUsers 200 response");

export const zSaveUserBody = zUser;

/**
 * saveUser 200 response
 */
export const zSaveUserResponse = zUser;

export const zChangePasswordBody = zUserServiceChangePassword;

export const zCheckPasswordBody = zUserServiceCheckPassword;

/**
 * getRegions_1 200 response
 */
export const zGetRegions1Response = z.array(z.string()).describe("getRegions_1 200 response");

/**
 * getRoles 200 response
 */
export const zGetRolesResponse = zRole;

export const zGetStressLevelsQuery = z.object({
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getStressLevels 200 response
 */
export const zGetStressLevelsResponse = z.array(zStressLevel).describe("getStressLevels 200 response");

export const zPostStressLevelBody = zStressLevel;

/**
 * postStressLevel 200 response
 */
export const zPostStressLevelResponse = zStressLevel;

export const zGetTeamStressLevelsQuery = z.object({
  region: z.string(),
  startDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
  endDate: z.string().describe("Date in the format yyyy-MM-dd'T'HH:mm:ssZZ"),
});

/**
 * getTeamStressLevels 200 response
 */
export const zGetTeamStressLevelsResponse = z
  .record(z.string(), z.array(zStressLevel))
  .describe("getTeamStressLevels 200 response");

export const zDeleteUserPath = z.object({
  id: z.string(),
});

export const zResetPasswordBody = zUserServiceResetPassword;

export const zResetPasswordPath = z.object({
  id: z.string(),
});

/**
 * Directory listing of the bulletin archive
 */
export const zGetStaticArchiveResponse = z.string().describe("Directory listing of the bulletin archive");

export const zGetStaticCaamlJsonPath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  region: z.string().describe("Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`"),
  lang: zLanguageCode,
});

/**
 * CAAML v6 JSON bulletins
 */
export const zGetStaticCaamlJsonResponse = zCaamlAvalancheBulletins;

export const zGetStaticCaamlXmlPath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  region: z.string().describe("Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`"),
  lang: zLanguageCode,
});

/**
 * CAAML v6 XML bulletins
 */
export const zGetStaticCaamlXmlResponse = z.string().describe("CAAML v6 XML bulletins");

export const zGetStaticCaamlJsonForPublicationPath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  publication: z.string().describe("Publication timestamp in the format yyyy-MM-dd_HH-mm-ss"),
  region: z.string().describe("Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`"),
  lang: zLanguageCode,
});

/**
 * CAAML v6 JSON bulletins
 */
export const zGetStaticCaamlJsonForPublicationResponse = zCaamlAvalancheBulletins;

export const zGetStaticMapPath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  publication: z.string().describe("Publication timestamp in the format yyyy-MM-dd_HH-mm-ss"),
  file: z
    .string()
    .describe(
      "Map file name, either `{daytime}_{region}_{mapLevel}[_bw]` for overview maps or `{region}_{bulletinId}[_PM][_bw]` for bulletin-specific maps",
    ),
});

/**
 * Danger map
 */
export const zGetStaticMapResponse = z.string().describe("Danger map");

export const zGetStaticMp3Path = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  region: z.string().describe("Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`"),
  lang: zLanguageCode,
});

/**
 * Audio bulletin
 */
export const zGetStaticMp3Response = z.string().describe("Audio bulletin");

export const zGetStaticEawsProblemsPath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
});

/**
 * Avalanche problems keyed by micro-region ID
 */
export const zGetStaticEawsProblemsResponse = z
  .record(z.string(), z.unknown())
  .describe("Avalanche problems keyed by micro-region ID");

export const zGetStaticEawsRatingsPath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  region: z.string().describe("Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`"),
});

/**
 * Danger ratings keyed by micro-region ID
 */
export const zGetStaticEawsRatingsResponse = z
  .record(z.string(), z.unknown())
  .describe("Danger ratings keyed by micro-region ID");

/**
 * Weather stations as GeoJSON
 */
export const zGetStaticWeatherStationsResponse = zWeatherStationsFeatureCollection;

export const zGetStaticWeatherStationsForDateTimePath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  dateTime: z.string().describe("Timestamp of the hourly snapshot in the format yyyy-MM-dd_HH-mm"),
});

/**
 * Weather stations as GeoJSON
 */
export const zGetStaticWeatherStationsForDateTimeResponse = zWeatherStationsFeatureCollection;

export const zGetStaticSimpleHtmlPath = z.object({
  date: z.iso.date().describe("Date of validity in the format yyyy-MM-dd"),
  region: z.string().describe("Region ID, e.g. `EUREGIO`, `AT-07`, `IT-32-BZ`, `IT-32-TN`"),
  lang: zLanguageCode,
});

/**
 * Simple HTML rendering of the bulletins
 */
export const zGetStaticSimpleHtmlResponse = z.string().describe("Simple HTML rendering of the bulletins");
